/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-01 12:38:58
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 18:22:05
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/LegalCategory/HOC/index.tsx
 */
import React from 'react';
import _HOC from 'src/layout/EditorPageLayout/EditorCollapsePageLayout/SectionHocWithData';
import {
  getContent,
  getCollapse,
  onCollapseChange,
  getLoaded,
  getMoveList,
} from '../slice';
import { useSelector } from 'react-redux';
import Header from 'src/pages/SalesChannelCategory/Components/Header';
import { hierarchyNameGenerator } from 'src/pages/SalesChannelCategory/PagesCategory/tools';

const HOC = (Comp, obj) => {
  const _obj = {
    getCollapse,
    getContent: getContent,
    getLoaded,
    useCustomCollapseTitle: true,
    onCollapseChange,
    customPropsGenerator: ({ uuid }) => {
      const moveList = useSelector(getMoveList(uuid));

      return { moveList };
    },
    getMoveList,
    titleGenerator: (data) => {
      const { name, fullUrl, numOfItems, path = [] } = data;
      const _name = hierarchyNameGenerator(name, path);
      return <Header title={_name} productsAmount={numOfItems} url={fullUrl} />;
    },
    openMargin: 1,
    ...obj,
  };
  return _HOC(Comp, _obj);
};
export default HOC;
